import * as React from 'react';
import { Button, Grid, GridColumn, Heading, IButtonProps, Modal, ModalContent, Notice, Text } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import useStores from '../stores/UseStores';

export enum ConfirmationType {
  EMAIL_REMOVAL,
}

const RemovalConfirmationModal = observer((): React.JSX.Element => {
  const {
    translateStore: { translate },
    accountInfoStore: {
      setRemovalModalState,
      removalModalOpen,
      removalModalData: { data },
    },
    emailRemoveStore: { deleteEmail },
  } = useStores();

  const getButtonProps = (): IButtonProps => {
    return {
      text: translate('accountPage.confirmationModal.removeEmail.button'),
      type: 'withdrawal',
      onClick: () => deleteEmail(data || ''),
    };
  };

  return (
    <Modal
      isOpen={removalModalOpen}
      onClose={() => setRemovalModalState(false)}
      aria-labelledby="remove-account-modal-title"
      initialFocusedElementId="confirm-button"
      size="6-col"
    >
      <ModalContent>
        <Text className="text-center">
          <Grid align={['center-sm', 'middle-sm']}>
            <GridColumn width={['sm-10']}>
              <Notice direction="vertical">
                <Heading className="h3" id="remove-account-modal-title">
                  <p>{translate('accountPage.confirmationModal.heading.email')}</p>
                </Heading>
              </Notice>
            </GridColumn>
            <GridColumn>
              <Button
                id="confirm-button"
                {...getButtonProps()}
                onClick={(e) => {
                  getButtonProps().onClick?.(e);
                  setRemovalModalState(false);
                }}
              />
            </GridColumn>
            <GridColumn>
              <Button link={true} onClick={() => setRemovalModalState(false)} text={translate('button.back')} iconLeft="#arrow-left" />
            </GridColumn>
          </Grid>
        </Text>
      </ModalContent>
    </Modal>
  );
});

export default RemovalConfirmationModal;
